import { Base } from '../Base';

export class FacilityDetail extends Base {
    facilitydisplayname : string;
    facilitymasterid : number; 
}

export class FacilityResponse extends Base {
    response?: Array<FacilityDetail>;
    constructor() {
        super();
    }
}